export default __webpack_public_path__ + "static/media/tablet 1.4901d3ad.png";